import React, { useState, useRef, useEffect } from 'react'
import { Text as RNText, TextStyle, TouchableOpacity, ViewStyle } from 'react-native'
import { useHistory } from 'react-router'
import { Button as MuiButton } from '@mui/material'
import { ChevronLeftRounded } from '@mui/icons-material'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied'
import { getDisplayNumber, useStores } from '@trivie/core'
import { Button, color, Text } from '@trivie/ui-mobile'
import { observer } from 'mobx-react-lite'
import { OtpEntry } from '@trivie/ui-web/components/otp-entry/otp-entry'

export const SMSScreen = observer(() => {
  const { userStore } = useStores()
  const { otpNotFound, setOtpNotFound, evaluateOTC, formattedPhoneNumber } = userStore

  const history = useHistory()

  const [otp, setOtp] = useState('')

  const pinRef = useRef<any>(null)

  useEffect(() => {
    setOtpNotFound(false)
  }, [])

  const resend = () => {
    setOtpNotFound(false)
    pinRef?.current?.clear()
    setOtp('')
    if (formattedPhoneNumber) {
      userStore.sendMagicLink(formattedPhoneNumber, 'engage', true)
    }
  }

  const login = () => {
    if (formattedPhoneNumber && otp) {
      evaluateOTC(otp, undefined, formattedPhoneNumber).then(async (data: any) => {
        if (userStore.status === 'error') {
          // history.replace('/magic')
        } else if (data.workspaces && data.workspaces.length > 1) {
          localStorage.removeItem('ml-error')
          history.replace('/workspaces')
        } else if (data.workspaces.length === 1) {
          localStorage.removeItem('ml-error')
          userStore.loginWorkspace(data.token, data.workspaces[0].access_code, () =>
            history.replace('/library'),
          )
        }
      })
    }
  }

  const onChange = (value: string) => {
    setOtpNotFound(false)
    setOtp(value)
  }

  return (
    <div style={ROOT}>
      <div style={CONTAINER}>
        <div style={CONTENT}>
          <div style={HEADER}>
            <Text style={HEADLINE} tx="Onboarding.Login.mobileContinue" variant="headline" />
            <Text
              variant="titleMedium"
              txOptions={{ number: getDisplayNumber(formattedPhoneNumber) }}
              style={TAGLINE}
              tx="Onboarding.Login.otp"
            />
            <OtpEntry onChange={onChange} />
            <Button
              accessibilityRole="link"
              accessibilityLabel="Continue"
              disabled={otp.length !== 4}
              style={SUBMIT}
              tx="Common.continue"
              onPress={login}
            />
            {otpNotFound && (
              <div style={ERROR_STATE}>
                <SentimentVeryDissatisfiedIcon
                  htmlColor={color.red}
                  style={{ marginRight: 12, fontSize: 20 }}
                />
                <span style={{ fontWeight: 700, fontSize: 12, color: 'rgba(255, 0, 0, 0.8)' }}>
                  We don't recognize that code.&nbsp;
                  <span style={{ fontWeight: 500 }}>
                    Please try again, or select Resend Code below or contact your administrator.
                  </span>
                </span>
              </div>
            )}
            <div
              style={{ flexDirection: 'row', justifyContent: 'center', display: 'flex', flex: 1 }}
            >
              <Text
                style={{ color: color.shade50, textAlign: 'center', alignSelf: 'center' }}
                variant="body1"
                tx="Onboarding.Login.contactAdminMobile"
              />
              <TouchableOpacity onPress={resend} style={{ alignSelf: 'center', marginLeft: 4 }}>
                <Text
                  tx="Onboarding.Login.sendItAgain"
                  variant="body1"
                  style={{ color: color.blue, textDecorationLine: 'underline', fontWeight: '600' }}
                />
              </TouchableOpacity>
            </div>
            <div style={{ marginTop: 32, width: 300, alignSelf: 'center' }}>
              <Text
                style={{ textAlign: 'center', color: color.shade50 }}
                tx="Onboarding.Login.havingTrouble"
                variant="body1"
              />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
            <MuiButton
              onClick={() => history.replace('/login/magic')}
              style={{ textTransform: 'none' }}
              startIcon={<ChevronLeftRounded style={{ color: color.shade70, fontSize: 24 }} />}
            >
              Back
            </MuiButton>
          </div>
        </div>
      </div>
    </div>
  )
})

const ENTRY_BOX: React.CSSProperties = {
  height: 49,
  width: 49,
  borderRadius: 10,
  backgroundColor: 'rgba(230, 230, 230, 1)',
  marginRight: 8,
  border: '0px solid black',
  fontSize: 24,
  fontWeight: 700,
}
const ROOT: React.CSSProperties = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
}
const CONTAINER: React.CSSProperties = {
  flexDirection: 'column',
  flex: 1,
  display: 'flex',
  maxHeight: 576,
  justifyContent: 'center',
  width: '100%',
  alignSelf: 'center',
}
const CONTENT: React.CSSProperties = {
  height: '100%',
  flex: 1,
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'center',
}
const HEADER: React.CSSProperties = {
  minWidth: 319,
  flexDirection: 'column',
  display: 'flex',
  marginBottom: 20,
}
const SUBMIT: ViewStyle = {
  marginHorizontal: 20,
  alignSelf: 'center',
  width: 335,
  marginTop: 20,
  marginBottom: 28,
}
const TAGLINE: TextStyle = {
  opacity: 0.5,
  textAlign: 'center',
  marginBottom: 50,
  width: 249,
  alignSelf: 'center',
}
const HEADLINE: TextStyle = { textAlign: 'center', marginBottom: 12 }
const NEED_HELP: TextStyle = {
  textAlign: 'center',
  alignSelf: 'center',
  width: 283,
  color: color.shade50,
  fontSize: 14,
  marginBottom: 12,
}
const ERROR_STATE: React.CSSProperties = {
  width: 349,
  height: 64,
  marginBottom: 25,
  borderRadius: 16,
  backgroundColor: 'rgba(249, 234, 234, 1)',
  paddingTop: 10,
  paddingBottom: 10,
  paddingRight: 20,
  display: 'flex',
  flexDirection: 'row',
  paddingLeft: 20,
  alignItems: 'center',
  alignSelf: 'center',
}
